import { ca } from '@cian/analytics';

export function trackFullscreenShow(objectType?: string) {
  ca('eventSite', {
    action: 'fullscreen',
    category: 'Infrastructure',
    label: 'show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
